import $ from "jquery";
import BD_Block from "@bd-core/bd-block";
import Store_SequenceHistory from "@bd-components/store-sequence-history";
import { compile } from "@bd-utils/handlerbars-helper";
// import BD_GAME_LOGIC from "@bd-core/game-logic";

export class Block_Document extends BD_Block {
  constructor() {
    super();

    this.type = "document";
    this.templateID = "document-template";

    this.elms = {
      continueBtn: ".js-continue",
    };

    this._events = this.getEvents();
  }

  getEvents() {
    // const elms = this.elms;
    return [];
  }

  beforeInit() {
    this.render();
    this.setGameState();
  }

  render() {
    const htmlTemplate = $("#" + this.templateID).html();
    const html = compile(htmlTemplate, this._data);
    $("#templateWrapper").html(html);
  }

  setGameState() {
    const showBackBtn = () => {
      if (Store_SequenceHistory.data) {
        $(this.elms.backWrapper).addClass("is-active");
      }
    };

    showBackBtn();
  }
}
